/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTEwIDE0djloLTEuNDl2LTcuNTFoLTcuNTF2LTEuNDl6bTEzIDB2MS41aC03LjUxdjcuNWgtMS40OXYtOXptLTEzLTEzdjloLTl2LTEuNDloNy41MXYtNy41MXptNS40OSAwdjcuNWg3LjUxdjEuNWgtOXYtOXoiLz48L3N2Zz4=";